document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector("[data-media-listing-page]")) {
        import(/* webpackChunkName: "media-listing" */ "/Features/MediaListing/js/media-listing.js").then(async (module) => {
            const mediaListing = new module.default();
            await mediaListing.init();
        });
    }
});
